import {createSelector} from 'reselect';

export const selectFetchDealerPlanningConfiguration = (state) => state.fetchDealerPlanningConfiguration;
export const selectPlanningConfiguration = (state) => selectFetchDealerPlanningConfiguration(state).planningConfiguration;

export const selectSaveDealerPlanningConfiguration = (state) => state.saveDealerPlanningConfiguration;

export const selectDealerPlanningLoading = createSelector(
  [
    selectFetchDealerPlanningConfiguration,
    selectSaveDealerPlanningConfiguration
  ],
  (fetchCfg, saveCfg) => fetchCfg.loading || saveCfg.loading
);
